[
  {
    "code": "DM-02",
    "name": "Saint Andrew"
  },
  {
    "code": "DM-03",
    "name": "Saint David"
  },
  {
    "code": "DM-04",
    "name": "Saint George"
  },
  {
    "code": "DM-05",
    "name": "Saint John"
  },
  {
    "code": "DM-06",
    "name": "Saint Joseph"
  },
  {
    "code": "DM-07",
    "name": "Saint Luke"
  },
  {
    "code": "DM-08",
    "name": "Saint Mark"
  },
  {
    "code": "DM-09",
    "name": "Saint Patrick"
  },
  {
    "code": "DM-10",
    "name": "Saint Paul"
  },
  {
    "code": "DM-11",
    "name": "Saint Peter"
  }
]